import React, { useState } from "react";
import { withSize } from "react-sizeme";
import PropTypes from "prop-types";
import buildGridFunc from "./gridCalculation.js";
import GridItemContainer from "./GridItemContainer.js";
import GridItem from "../Grid/GridItem.js";
import { arrayEquals } from "../../../../utils/gridHelpers.js";

import "./CoolGrid.scss";

const DEFAULT_MARDING_GRID = 10;
const DEFAULT_ROW_HEIGHT_GRID = 320;

const CoolGrid = ({ size, list, obj, containerClassName, isProUser }) => {
  const [height, setHeight] = useState(DEFAULT_ROW_HEIGHT_GRID);

  const { renderList, containerHeight } = buildGridFunc({
    list,
    obj,
    width: size.width,
    maxHeight: height,
    margin: DEFAULT_MARDING_GRID,
    rtl:
      window.location.href.includes("/he/") ||
      window.location.href.includes("/ar/")
        ? true
        : false,
    hideAds: isProUser,
  });

  return (
    <div style={{ height: containerHeight }} className={containerClassName}>
      {renderList.map((item, i) => {
        return (
          <GridItemContainer
            item={item.folder ? item.folder + 1 : item}
            key={item.id}
            shouldRerender={renderList.length - 20 > i}
            width={size.width}
          >
            <GridItem itemId={item.id} />
          </GridItemContainer>
        );
      })}
    </div>
  );
};

const listWasChanged = (prevProps, nextProps) => {
  return (
    arrayEquals(prevProps.list, nextProps.list) &&
    prevProps.size.width === nextProps.size.width
  );
};

const MemoizeCoolGrid = React.memo(CoolGrid, listWasChanged);
export default withSize({ monitorWidth: true })(MemoizeCoolGrid);

CoolGrid.propTypes = {
  list: PropTypes.array.isRequired,
  containerClassName: PropTypes.string,
  gutter: PropTypes.number,
  rowHeight: PropTypes.number,
  RenderComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
};

CoolGrid.defaultProps = {
  list: [],
  containerClassName: "",
  gutter: 10,
};
